<template lang="pug">
        main
            slot
</template>

<script>
export default {
  name: 'DefaultLayout'
}
</script>
